webpackJsonpPois([2],{

/***/ 1985:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1986);

__webpack_require__(355);

var _client = __webpack_require__(356);

var _client2 = _interopRequireDefault(_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _client2.default)(window.__initialState);

/***/ }),

/***/ 1986:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 355:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[1985]);


// WEBPACK FOOTER //
// list.c0f4fa81c84d598317a7.js